import { type FilterItem } from 'widgets/FilterEditor/model'

export const MultiRecurringTypeKeys = new Set(['broadcasts_recurring_settings.type'])

export const isMultiRecurringTypeWidget = (filterItem: FilterItem) =>
  MultiRecurringTypeKeys.has(filterItem.key)
